import { render, staticRenderFns } from "./FolderFrame.vue?vue&type=template&id=3586b2f9&"
import script from "./FolderFrame.vue?vue&type=script&lang=js&"
export * from "./FolderFrame.vue?vue&type=script&lang=js&"
import style0 from "./FolderFrame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports